import req from "../http";

const c104 = {
  // 同步104履歷
  postResumeCrawlJob(params) {
    return req("post", "/Resume104Crawler/Add104ResumeCrawlJob", params);
  },

  // 取得 104履歷 結果
  getCrawlerResult(userId) {
    return req("get", `/Resume104Crawler/CheckCrawlerResult/${userId}`);
  },
};

export default c104;